var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 4.102l1.125-1.497c.281-.38.731-.605 1.202-.605.823 0 1.498.675 1.498 1.498v1.56c0 .922.38 1.808 1.048 2.44l5.955 5.682A17.375 17.375 0 0133.5 25.744C33.5 32.517 28.016 38 21.244 38H20c-7.453 0-13.5-6.047-13.5-13.5v-.267c0-3.431 1.364-6.722 3.79-9.148l.246-.246a1.597 1.597 0 011.125-.464c.879 0 1.589.71 1.589 1.59v6.285c0 2.482 2.018 4.5 4.5 4.5s4.5-2.018 4.5-4.5v-.274a4.78 4.78 0 00-1.4-3.375l-2.713-2.714A9.026 9.026 0 0117.3 4.102z"
  })));
}
export default SvgTrending;